import { useEffect } from 'react';
import { Feather, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function Screen1Hook({ onNext, onSkip }) {
  useEffect(() => {
    document.title = 'The Storyteller';
  }, []);

  return (
    <div className="story-page flex flex-col items-center justify-center px-6 fade-in">
      <div className="relative z-10 text-center max-w-sm w-full">
        <div className="flex items-center justify-center gap-2 mb-10">
          <Feather className="w-5 h-5 text-[var(--story-primary)]" />
          <span className="story-label">
            The Storyteller
          </span>
        </div>

        <h1 className="story-title text-3xl sm:text-4xl mb-5">
          Your story deserves to be remembered.
        </h1>

        <p className="story-body text-base leading-relaxed mb-8">
          The Storyteller helps turn memories and conversations into a beautifully written story.
        </p>

        <Button
          onClick={onNext}
          className="story-button-primary px-8 text-base"
        >
          Start your story
          <ArrowRight className="ml-2 w-4 h-4" />
        </Button>

        {onSkip && (
          <button
            onClick={onSkip}
            className="mt-5 text-sm text-[#A09890] dark:text-[#5C5650] hover:text-[#6B6560] dark:hover:text-[#9C9590] transition-colors"
          >
            Skip — I already know what I want
          </button>
        )}
      </div>
    </div>
  );
}
